<template>
    <div>
        <v-dialog v-model="dialog" persistent width="700">
            <v-card>
                <v-container>
                    <v-row>
                        <v-col>
                            <p class="text-center">
                                QUESTIONNAIRE RELATIF A L’ETAT DE SANTE DU SPORTIF MINEUR EN VUE DE LA PARTICIPATION A
                                UNE
                                MANIFESTATION SPORTIVE COMPETITIVE, HORS DISCIPLINES A CONTRAINTES PARTICULIERES (*)
                                <br />
                            </p>
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col>
                            <v-alert border="bottom" border-color="primary-dark">Avertissement à destination des parents
                                ou de la
                                personne ayant l'autorité parentale : Il est préférable que ce questionnaire soit
                                complété par votre
                                enfant, c'est à vous d'estimer à quel âge il est capable de le faire. Il est de
                                votre responsabilité de vous assurer que le questionnaire est correctement complété et
                                de suivre les
                                instructions en fonction des réponses données.</v-alert>
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col>
                            <v-alert variant="outlined">
                                Faire du sport : c'est recommandé pour tous. En as-tu parlé avec un médecin ? T'a-t-il
                                examiné (e) pour
                                te conseiller ? Ce questionnaire n'est pas un contrôle. Tu réponds par OUI ou par NON,
                                mais il n'y a pas
                                de bonnes ou de mauvaises
                                réponses. Tu peux regarder ton carnet de santé et demander à tes parents de t'aider.
                            </v-alert>
                        </v-col>
                    </v-row>
                    <v-divider></v-divider>
                    <v-row>
                        <v-col>
                            <div>
                                <span v-if="inscription.coureur.champs.sexe.value == 'M'">Tu es un <b>garçon</b></span>
                                <span v-if="inscription.coureur.champs.sexe.value == 'F'">Tu es une <b>fille</b></span>
                            </div>
                        </v-col>
                        <v-col>
                            <div v-if="inscription.coureur.champs.date_naissance.value != ''">
                                Ton âge: <b>{{ this.$moment().diff(inscription.coureur.champs.date_naissance.value,
                                    "years") }} ans</b>
                            </div>
                            <div v-else>Ton âge: Non renseigné</div>
                        </v-col>
                    </v-row>
                    <v-divider></v-divider>
                    <v-row>
                        <v-col>
                            <v-alert><b>Depuis l'année dernière</b></v-alert>
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col>
                            <ul>
                                <li class="mb-1" v-for="(item, index) in items_annee_derniere" :key="index">
                                    {{ item }}
                                </li>
                            </ul>
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col>
                            <v-alert><b>Depuis un certain temps (plus de 2 semaines)</b></v-alert>
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col>
                            <ul>
                                <li class="mb-1" v-for="(item, index) in items_deux_semaines" :key="index">
                                    {{ item }}
                                </li>
                            </ul>
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col>
                            <v-alert><b>Ajourd'hui</b></v-alert>
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col>
                            <ul>
                                <li class="mb-1" v-for="(item, index) in items_ajd" :key="index">
                                    {{ item }}
                                </li>
                            </ul>
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col>
                            <v-alert><b>Questions pour les parents</b></v-alert>
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col>
                            <ul>
                                <li class="mb-1" v-for="(item, index) in items_parents" :key="index">
                                    {{ item }}
                                </li>
                            </ul>
                        </v-col>
                    </v-row>
                    <v-divider> </v-divider>
                    <div>
                        <v-btn @click="$emit('unvalidate')" color="dark-red" class="btn-multiline mb-3 py-1"> <span
                                class="text-wrap">J'ai répondu OUI à une ou plusieurs questions, je dois fournir un
                                certificat médical
                                pour valider mon inscription</span></v-btn>
                        <v-btn @click="$emit('validate')" color="dark-green" class="btn-multiline mb-3 py-1"><span
                                class="text-wrap">J'ai répondu NON à toutes les questions, ce questionnaire valide mon
                                inscription</span></v-btn>
                    </div>
                </v-container>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>
export default {
    props: ["inscription"],
    data() {
        return {
            dialog: true,
            items_annee_derniere: [
                "Es-tu allé (e) à l'hôpital pendant toute une journée ou plusieurs jours ?",
                "As-tu été opéré (e) ?",
                "As-tu beaucoup plus grandi que les autres années ?",
                "As-tu beaucoup maigri ou grossi ?",
                "As-tu eu la tête qui tourne pendant un effort ?",
                "As-tu perdu connaissance ou es-tu tombé sans te souvenir de ce qui s'était passé ?",
                "As-tu reçu un ou plusieurs chocs violents qui t'ont obligé à interrompre un moment une séance de sport ?",
                "As-tu eu beaucoup de mal à respirer pendant un effort par rapport à d'habitude ?",
                "As-tu eu beaucoup de mal à respirer après un effort ?",
                "As-tu eu mal dans la poitrine ou des palpitations (le cœur qui bat très vite) ?",
                "As-tu commencé à prendre un nouveau médicament tous les jours et pour longtemps ?",
                "As-tu arrêté le sport à cause d'un problème de santé pendant un mois ou plus ?",
            ],
            items_deux_semaines: [
                "Te sens-tu très fatigué (e) ?",
                "As-tu du mal à t'endormir ou te réveilles-tu souvent dans la nuit ?",
                "Sens-tu que tu as moins faim ? que tu manges moins ?",
                "Te sens-tu triste ou inquiet ?",
                "Pleures-tu plus souvent ?",
                "Ressens-tu une douleur ou un manque de force à cause d'une blessure que tu t'es faite cette année ?",
            ],
            items_ajd: ["Penses-tu quelquefois à arrêter de faire du sport ou à changer de sport ?", "Penses-tu avoir besoin de voir ton médecin pour continuer le sport ?", "Souhaites-tu signaler quelque chose de plus concernant ta santé ?"],
            items_parents: [
                "Quelqu'un dans votre famille proche a-t-il eu une maladie grave du cœur ou du cerveau, ou est-il décédé subitement avant l'âge de 50 ans ?",
                "Etes-vous inquiet pour son poids ? Trouvez-vous qu'il se nourrit trop ou pas assez ?",
                "Avez-vous manqué l'examen de santé prévu à l'âge de votre enfant chez le médecin ? (Cet examen médical est prévu à l'âge de 2 ans, 3 ans, 4 ans, 5 ans, entre 8 et 9 ans, entre 11 et 13 ans et entre 15 et 16 ans.)",
            ],
        };
    },
};
</script>

<style lang="scss" scoped>
.btn-multiline {
    height: auto;
}

.btn-multiline>span {
    width: 100%;
}
</style>